import { DataRepository, DownloadProvider } from "../domain/interfaces";

export class BrowserDownloadProvider implements DownloadProvider {
  downloaded = undefined;
  constructor() {
  }
  
  download(csvContent) {
    this.downloaded = csvContent;
    csvContent = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", csvContent);
    link.setAttribute("download", "MiPlan.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
  
}